import BackButton from "../utils/backButton";
import { GetGlobalColor } from "../utils/globalColors";

const Colors = () => {
  const color = GetGlobalColor();

  const setNewAvatar = async (color) => {
    localStorage.setItem('colorScheme', color);
    window.location.reload();
  };

  return (
    <>
      <div className={`box card-bg-${color}`}>
        <p className="text-xl font-bold wtext mb-4">Spremeni barvo</p>
        <div className="grid grid-cols-3 gap-4">
          <div onClick={() => setNewAvatar("forest")} className="color-box card-bg-forest "></div>
          <div onClick={() => setNewAvatar(null)} className="color-box primary-bg"></div>
          <div onClick={() => setNewAvatar("sunset")} className="color-box card-bg-sunset "></div>
          <div onClick={() => setNewAvatar("purple")} className="color-box card-bg-purple "></div>
          <div onClick={() => setNewAvatar("teal")} className="color-box card-bg-teal "></div>
          <div onClick={() => setNewAvatar("amber")} className="color-box card-bg-amber "></div>
        </div>
      </div>
    </>
  )
}

export default Colors;

